import { render, staticRenderFns } from "./KeyboardNew.vue?vue&type=template&id=428992f8&scoped=true&"
import script from "./KeyboardNew.vue?vue&type=script&lang=js&"
export * from "./KeyboardNew.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardNew.vue?vue&type=style&index=0&id=428992f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428992f8",
  null
  
)

export default component.exports